import * as Yup from 'yup';

import { SPECIAL_COLUMNS } from '_components/_core/Table';
import FORMATTERS from 'helpers/formatters';

export const DEFAULT_COLUMNS = [
  'description',
  'amount',
  'due_date',
  'charge_type',
  'payment_method_id',
  'id',
];

export const TABLE_COLUMNS = [
  {
    label: 'Ações',
    keyName: 'id',
    align: 'center',
    width: 10,
    specialType: SPECIAL_COLUMNS.ACTIONS,
    order: 1,
  },
  {
    label: 'Descrição',
    keyName: 'description',
    align: 'left',
    width: 40,
    order: 2,
  },
  {
    label: 'Valor',
    keyName: 'amount',
    align: 'right',
    width: 15,
    formatter: FORMATTERS.NUMBER,
    order: 3,
  },
  {
    label: 'Vencimento',
    keyName: 'due_date',
    align: 'center',
    width: 15,
    formatter: FORMATTERS.DATE_DDMMYYYY,
    order: 4,
  },
  {
    label: 'Tipo',
    keyName: 'charge_type',
    align: 'center',
    width: 10,
    formatter: value => (value === 'SINGLE' ? 'Única' : 'Recorrente'),
    order: 5,
  },
  {
    label: 'Método',
    keyName: 'payment_method_name',
    align: 'center',
    width: 10,
    order: 6,
  },
];

export const ValidationSchema = Yup.object().shape({
  description: Yup.string().required('Campo obrigatório').nullable(),
  amount: Yup.number().required('Campo obrigatório').nullable(),
  due_date: Yup.date().required('Campo obrigatório').nullable(),
  charge_type: Yup.string().required('Campo obrigatório').nullable(),
  payment_method_id: Yup.string().required('Campo obrigatório').nullable(),
});

export const convertBase64ToBlob = (base64, fileName) => {
  // Convert base64 to blob
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: 'application/pdf' });

  // Create download link
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${fileName}.pdf`);
  document.body.appendChild(link);

  // Trigger download
  link.click();

  // Clean up
  window.URL.revokeObjectURL(url);
  document.body.removeChild(link);
};
